export const defaultCustomStyles: any = {
  gridColumnTemplate: '',
  fontSize: '16px',
  fontWeight: '400',
  border: 'none',
  borderRadius: '0',
  padding: '0',
  backgroundColor: '#ffffff',
  headerColor: '#7A7A7A',
  headerBorderTop: 'none',
  headerBorderBottom: '1px solid #F0EFEF',
  headerBorderRight: 'none',
  headerFontSize: '14px',
  headerFontWeight: '600',
  headerBackground: '#fff',
  headerHoverBackground: '',
  headerCursor: 'normal',
  headerPadding: '16px',
  headerMinHeight: '50px',
  headerMinWidth: '150px',
  bodyFontSize: '16px',
  bodyFontWeight: '600',
  bodyColor: '#141414',
  bodyCursor: 'auto',
  bodyRowBg: '#ffffff',
  bodyOddRowBg: '#ffffff',
  bodyEvenRowBg: '#ffffff',
  bodyHoverRowBg: '#fbfbfb',
  bodyBorderBottom: '1px solid #F0EFEF',
  bodyBorderRight: 'none',
  bodyPadding: '16px',
  bodyMinHeight: '',
  selectBoxLeft: '10px',
  hoverColumnBg: 'none'
};
